export default "__VITE_ASSET__12a94ddb__"